import _ from 'lodash'
import Numeral from 'numeral';
import {
    GoogleMap,
    Marker,
    InfoWindow
} from "vue3-google-map"

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default defineNuxtPlugin(nuxtApp => {

    nuxtApp.vueApp.component('VueDatePicker', VueDatePicker)
    nuxtApp.vueApp.component("GoogleMap", GoogleMap)
    nuxtApp.vueApp.component("Marker", Marker)
    nuxtApp.vueApp.component("InfoWindow", InfoWindow)

    return {
        provide: {
            get: (obj, key, empt = '') => {
                return _.get(obj, key, empt);
            },
            eq: (obj, key) => {
                return _.eq(obj, key);
            },
            head: (obj) => {
                return _.head(obj);
            },
            last: (obj) => {
                return _.last(obj);
            },
            size: (obj) => {
                return _.size(obj);
            },
            toUpper: (obj) => {
                return _.toUpper(obj);
            },
            uniqBy: (obj, key) => {
                return _.uniqBy(obj, key);
            },
            includes: (arr, key) => {
                return _.includes(arr, key);
            },
            toNumber: (string) => {
                return _.toNumber(string);
            },
            round: (obj, key) => {
                return _.round(obj, key);
            },
            removeHtmlCode: (element) => {
                let div = document.createElement("div");
                div.innerHTML = element;
                return div.innerText;
            },
            useState: (element) => {
                return useState(element).value;
            },
            getState: (element, key) => {
                return _.get(useState(element).value, key);
            },
            isLoggedIn: () => {
                return !_.isEmpty(useState('auth.user.info').value);
            },
            lang: (obj, key = '') => {
                const {
                    locale
                } = useI18n({
                    useScope: 'global'
                })
                let currentLocale = _.get(locale, 'value');
                currentLocale = _.eq(currentLocale, 'zh-hk') ? 'tc' : currentLocale;
                const params = key ? `${key}.${currentLocale}` : currentLocale;
                return _.get(obj, params);
            },
            icon: (icon, type = 'fa') => {
                return `${type} fa-${icon}`;
            },
            numeral: (num, format = '0,0') => {
                return Numeral(num).format(format);
            },
            inFeatureKeys: (key) => {
                const siteInfo = useState('site.info').value;
                const features = _.chain(siteInfo).get('distributor.features').mapKeys(a => a.key).keys().value();
                return _.includes(features, key);
            },
            siteInfo: () => {
                return useState('site.info').value;
            },
            longSymbol: (currency = 'hkd') => {
                const currencies = useState('site.currencies').value;
                const long_symbol = _.get(currencies, `${currency}.long_symbol`, 'HK$')
                return long_symbol
            },
            priceTag: (price, decimal = true) => {
                const long_symbol = _.get(useState('site.current_currency').value, 'long_symbol', 'HK$')
                return `${long_symbol} ${Numeral(price).format(decimal ? '0,0.00': '0,0')}`;
            },
            currencyPriceTag: (price, currency = 'hkd', decimal = true) => {
                const currencies = useState('site.currencies').value;
                const long_symbol = _.get(currencies, `${currency}.long_symbol`, 'HK$')
                return `${long_symbol} ${Numeral(price).format(decimal ? '0,0.00': '0,0')}`;
            },
            coinTag: (price, decimal = false) => {
                return `${Numeral(price).format(decimal ? '0,0.00': '0,0')}`;
            },
            siteLogo() {
                const {
                    locale
                } = useI18n({
                    useScope: 'global'
                })
                let currentLocale = _.get(locale, 'value');
                currentLocale = _.eq(currentLocale, 'zh-hk') ? 'tc' : currentLocale;
                const siteInfo = useState('site.info').value;
                const universal_header_logo = _.chain(siteInfo).get('site.pages').find(a => a.href === 'universal').get('sections').find(a => a.key, 'universal_header').get('items').find(a => a.key, 'universal_header_logo').value();
                const elementPath = _.get(universal_header_logo, `element.src.${currentLocale}`)
                return elementPath;
            }
        }
    }
})